import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOriginPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 22",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.70833 8.41667C9.70833 9.02445 9.46689 9.60735 9.03712 10.0371C8.60735 10.4669 8.02445 10.7083 7.41667 10.7083C6.80888 10.7083 6.22598 10.4669 5.79621 10.0371C5.36644 9.60735 5.125 9.02445 5.125 8.41667C5.125 7.80888 5.36644 7.22598 5.79621 6.79621C6.22598 6.36644 6.80888 6.125 7.41667 6.125C8.02445 6.125 8.60735 6.36644 9.03712 6.79621C9.46689 7.22598 9.70833 7.80888 9.70833 8.41667Z",
		stroke: "#086ED6",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9171 18.5C12.9171 19.5129 10.4549 20.3333 7.41711 20.3333C4.37927 20.3333 1.91711 19.5129 1.91711 18.5M8.56936 16.2028C8.25973 16.5007 7.84677 16.6671 7.41711 16.6671C6.98745 16.6671 6.57448 16.5007 6.26486 16.2028C3.43327 13.4592 -0.36081 10.3948 1.48902 5.94533C2.49094 3.53908 4.89261 2 7.41711 2C9.94161 2 12.3442 3.54 13.3452 5.94533C15.1932 10.3884 11.4083 13.4684 8.56936 16.2028Z",
		stroke: "#086ED6",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgOriginPin;
